import React, { Component } from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from './Helmet';

const Title = 'Product Management Software and Tools | Canny';
const Description =
  "Canny is built for product managers. Get all the tools you need in one place — feedback management, roadmaps, changelogs — it's all here!";
const Image = 'https://canny.io/images/canny-social.png';
const ProductManagementUrl = 'https://canny.io/use-cases/product-management';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${ProductManagementUrl}#webpage`,
    url: ProductManagementUrl,
    name: 'Product Management - Canny',
    description:
      'Learn how Canny helps product managers collect feedback, prioritize roadmaps, and communicate updates to build better products.',
    inLanguage: 'en',
    about: { '@id': 'https://canny.io/#app' },
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createWebApplicationItemList(
    `${ProductManagementUrl}#capabilities`,
    'Product Management Capabilities',
    [
      {
        name: 'Centralize Customer Feedback',
        description:
          'Collect and organize feedback from multiple channels in one place for easy access and prioritization.',
      },
      {
        name: 'Prioritize Features by Impact',
        description:
          'Rank initiatives based on customer demand, business impact, and strategic value to focus on what matters most.',
      },
      {
        name: 'Communicate Roadmaps Effectively',
        description:
          'Share clear, transparent product roadmaps with stakeholders and customers to align expectations.',
      },
      {
        name: 'Close the Feedback Loop',
        description:
          'Notify users when their requests are addressed and demonstrate that their input drives product development.',
      },
    ],
  ),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Use Cases', item: 'https://canny.io/use-cases' },
    { name: 'Product Management', item: ProductManagementUrl },
  ]),
]);

export default class LandingProductManagementHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: ProductManagementUrl },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}>
        <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
      </Helmet>
    );
  }
}
